import React from "react";
import { Input, InputProps } from "./Input";
import SearchIcon from "@mui/icons-material/Search";

export interface SearchInputProps extends InputProps {}

const SearchInput = (props: SearchInputProps) => {
  const icon = <SearchIcon className="flex h-full items-center" />;
  return <Input icon={icon} {...props} />;
};

export const filterMatches = <T,>(
  searchItems: T[],
  getSearchFields: (item: T) => string,
  search: string
): T[] => {
  if (!search.trim()) {
    return searchItems;
  }
  const matches = searchItems.map((item) => {
    return { item, matches: numberMatches(getSearchFields(item), search) };
  });

  const max = matches.reduce((a, b) => Math.max(a, b.matches), 0);
  const finalMatches = max <= 0 ? [] : matches.filter((m) => m.matches === max);
  return finalMatches.map((m) => m.item);
};

const numberMatches = (item: string, search: string) => {
  const searchWords = search.split(" ");
  const formattedTitle = item.replace(/\s/gi, "").toLowerCase();
  return searchWords.filter((word) => {
    const formattedWord = word.replace(/\s/gi, "").toLocaleLowerCase();
    return formattedTitle.includes(formattedWord);
  }).length;
};

export { SearchInput };
